<div class="card-header bg-light">
    <h3 class="card-title mb-0">
        <i *ngIf="this.id && !visualizar" class="fas fa-pencil-alt pr-2"></i>
        <i *ngIf="this.id && visualizar" class="fas fa-search pr-2"></i>
        <i *ngIf="!this.id" class="far fa-file pr-2"></i>
        {{ tituloModal }}
    </h3>
</div>

<div class="card-body wrapper">
    <form class="needs-validation" novalidate id="myForm" #f="ngForm">
        <div class="row mb-2">

            <div class="col-md-6 mb-2">
                <label for="identificador" class="mb-1">Identificador</label>
                <div class="input-group input-group-sm">
                    <input type="text" id="identificador" class="form-control form-control-sm"
                        [ngModel]="model.identificador" [ngModelOptions]="{standalone: true}" readonly
                        placeholder="Gerado automaticamente" />
                    <div class="input-group-append" *ngIf="!visualizar && id === 0">
                        <button type="button" class="btn btn-info" (click)="abrirModalSelecionarQuestao()"
                            title="Buscar ou criar questão incidental">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="descricao" class="mb-1">Descrição</label>
                <textarea id="descricao" class="form-control form-control-sm" rows="3" [(ngModel)]="model.descricao"
                    [ngModelOptions]="{standalone: true}" [readonly]="visualizar || bloqueado || modoReuso || alterar"
                    maxlength="500">
                </textarea>
            </div>
            <div class="col-md-12 mb-2">
                <label for="criterioAplicavel" class="mb-1">Critérios Aplicáveis</label>
                <textarea id="criterioAplicavel" class="form-control form-control-sm" rows="2"
                    [(ngModel)]="model.criterioAplicavel" [ngModelOptions]="{standalone: true}"
                    [readonly]="visualizar || bloqueado || modoReuso || alterar">
                  </textarea>
            </div>

            <div class="col-md-12 mb-2">
                <label for="infRequerida" class="mb-1">Informações Requeridas/Fontes</label>
                <textarea id="infRequerida" class="form-control form-control-sm" rows="2"
                    [(ngModel)]="model.infRequerida" [ngModelOptions]="{standalone: true}"
                    [readonly]="visualizar || bloqueado || modoReuso || alterar">
                </textarea>
            </div>
            <div class="col-md-12 mb-2">
                <label for="inputTecnicaAuditoria" class="mb-1">Técnicas de Auditoria</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input [hidden]="visualizar || bloqueado || alterar" type="text" id="inputTecnicaAuditoriaSel"
                        class="form-control form-control-sm" readonly [ngModel]="tecnicaAuditoriaSelecionada?.nome"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar || bloqueado || alterar" class="input-group-append">
                        <button type="button" class="btn btn-info" (click)="exibirModalTecnicaAuditoria()"
                            title="Buscar Técnica de Auditoria">
                            <i class="fas fa-search"></i>
                        </button>
                        <button type="button" class="btn btn-success ml-1" (click)="addTecnicaAuditoria()"
                            title="Adicionar a Técnica de Auditoria selecionada na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceTecnicaAuditoria" matSortDisableClear matSort
                        matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['descricao', 'actions']" class="bg-light">
                        </tr>

                        <ng-container matColumnDef="descricao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Descrição
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.tecnicaAuditoria.nome">-</span>
                                <span *ngIf="element?.tecnicaAuditoria.nome">{{
                                    element.tecnicaAuditoria.nome }}</span>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar && !alterar" (click)="excluirTecnicaAuditoria(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: ['descricao', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceTecnicaAuditoria.data?.length > 0">
                        Nenhuma técnica de auditoria vinculada
                    </h5>
                    <mat-paginator #tabelaTecnicaAuditoriaPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="atividadeRelacionada" class="mb-1">Atividade Relacionada</label>
                <input type="text" id="atividadeRelacionada" class="form-control form-control-sm"
                    [(ngModel)]="model.atividadeRelacionada" [ngModelOptions]="{standalone: true}"
                    [readonly]="visualizar || bloqueado || modoReuso" />
            </div>


            <div class="col-md-12 mb-2">
                <label for="inputRiscoDigitado" class="mb-1">Riscos Associados</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input [hidden]="visualizar || bloqueado" type="text" id="inputRiscoDigitado"
                        class="form-control form-control-sm" maxlength="255" [(ngModel)]="riscoDigitado"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar || bloqueado" class="input-group-append">
                        <button type="button" class="btn btn-success ml-1" (click)="addRiscoDigitado()"
                            title="Adicionar o Risco digitado na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceRisco" matSortDisableClear matSort matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['descricao', 'actions']" class="bg-light">
                        </tr>

                        <ng-container matColumnDef="descricao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Descrição
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.descricao">-</span>
                                <span *ngIf="element?.descricao">
                                    {{element.descricao }}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar" (click)="excluirRisco(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: ['descricao', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceRisco.data?.length > 0">
                        Nenhum Risco associado
                    </h5>
                    <mat-paginator #tabelaRiscoPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>

            <div class="col-md-12 mb-2">
                <label for="inputCausaDigitada" class="mb-1">Causas</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input [hidden]="visualizar || bloqueado" type="text" id="inputCausaDigitada"
                        class="form-control form-control-sm" maxlength="255" [(ngModel)]="causaDigitada"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar || bloqueado" class="input-group-append">
                        <button type="button" class="btn btn-success ml-1" (click)="addCausaDigitada()"
                            title="Adicionar a Causa digitada na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceCausa" matSortDisableClear matSort matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['descricao', 'actions']" class="bg-light">
                        </tr>

                        <ng-container matColumnDef="descricao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Descrição
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.descricao">-</span>
                                <span *ngIf="element?.descricao">
                                    {{element.descricao }}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar" (click)="excluirCausa(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: ['descricao', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceCausa.data?.length > 0">
                        Nenhuma Causa associada
                    </h5>
                    <mat-paginator #tabelaCausaPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>


            <div class="col-md-12 mb-2">
                <label for="inputConsequenciaDigitada" class="mb-1">Consequências</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input [hidden]="visualizar || bloqueado" type="text" id="inputConsequenciaDigitada"
                        class="form-control form-control-sm" maxlength="255" [(ngModel)]="consequenciaDigitada"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar || bloqueado" class="input-group-append">
                        <button type="button" class="btn btn-success ml-1" (click)="addConsequenciaDigitada()"
                            title="Adicionar a Consequência digitada na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceConsequencia" matSortDisableClear matSort
                        matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['descricao', 'actions']" class="bg-light">
                        </tr>

                        <ng-container matColumnDef="descricao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Descrição
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.descricao">-</span>
                                <span *ngIf="element?.descricao">
                                    {{element.descricao }}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar" (click)="excluirConsequencia(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: ['descricao', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceConsequencia.data?.length > 0">
                        Nenhuma Consequência associada
                    </h5>
                    <mat-paginator #tabelaConsequenciaPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>

            <div class="col-md-12 mb-2">
                <label for="inputControleDigitado" class="mb-1">Controles Associados</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input [hidden]="visualizar || bloqueado" type="text" id="inputControleDigitado"
                        class="form-control form-control-sm" maxlength="255" [(ngModel)]="controleDigitado"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar || bloqueado" class="input-group-append">
                        <button type="button" class="btn btn-success ml-1" (click)="addControleDigitado()"
                            title="Adicionar o Controle digitado na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceControle" matSortDisableClear matSort
                        matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['descricao', 'actions']" class="bg-light">
                        </tr>

                        <ng-container matColumnDef="descricao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Descrição
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.descricao">-</span>
                                <span *ngIf="element?.descricao">
                                    {{element.descricao }}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar" (click)="excluirControle(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: ['descricao', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceControle.data?.length > 0">
                        Nenhum Controle associado
                    </h5>
                    <mat-paginator #tabelaControlePaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>

            <div class="col-md-4 mb-2">
                <label for="inputTipoTeste" class="mb-1">Tipo dos Testes</label>
                <ng-select id="tipoteste" [readonly]="visualizar || bloqueado" name="tipoTeste" [(ngModel)]="model.tipoTeste"
                    placeholder="Selecione um tipo">
                    <ng-option *ngFor="let tipoTeste of tiposTesteQuestaoIncidental" [value]="tipoTeste.value">
                        {{ tipoTeste.text }}
                    </ng-option>
                </ng-select>
            </div>

            <div class="col-md-4 mb-2">
                <label for="inputAmostraVinculadaId" class="mb-1">Amostra Vinculada</label>
                <ng-select id="amostraVinculadaId" [readonly]="visualizar || alterar" name="amostraVinculadaId"
                    [(ngModel)]="model.amostraVinculadaId" placeholder="Selecione uma amostra">
                    <ng-option *ngFor="let amostra of amostras" [value]="amostra.id">
                        {{ amostra.nome }}
                    </ng-option>
                </ng-select>
            </div>

            <div class="col-md-12 mb-2">
                <label for="inputProcedimentoSel" class="mb-1">Procedimentos</label>
                <div class="input-group input-group-sm mb-2" style="width: 100%;">
                    <input [hidden]="visualizar || alterar" type="text" id="inputProcedimentoSel"
                        class="form-control form-control-sm" readonly [ngModel]="procedSelecionado?.nome"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar || alterar" class="input-group-append">
                        <button type="button" class="btn btn-info" (click)="exibirModalProcedimento()"
                            title="Buscar Procedimento">
                            <i class="fas fa-search"></i>
                        </button>
                        <button type="button" class="btn btn-success ml-1" (click)="addProcedimentoSelecionado()"
                            title="Adicionar o Procedimento selecionado na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input [hidden]="visualizar || alterar" type="text" id="inputProcedimentoDigitado"
                        class="form-control form-control-sm" maxlength="255" [(ngModel)]="procedDigitado"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar || alterar" class="input-group-append">
                        <button type="button" class="btn btn-success ml-1" (click)="addProcedimentoDigitado()"
                            title="Adicionar o Procedimento digitado na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceProced" matSortDisableClear matSort matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['descricao', 'actions']" class="bg-light">
                        </tr>

                        <ng-container matColumnDef="descricao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Descrição
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.descricao">-</span>
                                <span *ngIf="element?.descricao">{{
                                    element.descricao }}</span>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar && !alterar" (click)="excluirProcedimento(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: ['descricao', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceProced.data?.length > 0">
                        Nenhum procedimento vinculado
                    </h5>
                    <mat-paginator #tabelaProcedPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="card-footer">
    <div class="d-flex justify-content-between w-100">
        <div class="btn-group" [hidden]="visualizar">
            <button class="btn btn-primary btn-sm mr" (click)="salvar()">
                <i class="far fa-save"></i> Salvar
            </button>
        </div>
        <button type="button" class="btn btn-default btn-sm" (click)="cancelar()" [hidden]="visualizar">
            <i class="fas fa-times"></i> Cancelar
        </button>
        <button type="button" class="btn btn-default btn-sm" (click)="fechar()" [hidden]="!visualizar">
            <i class="fas fa-times"></i> Sair
        </button>
    </div>
</div>